<template>
  <b-tab title="Assignment via Temporary Worker Service ('Inside IR35 Assignment')" active>
    <h2>Assignment via Temporary Worker Service ('Inside IR35 Assignment')</h2>
    <transition name="fade">
      <b-row class="justify-content-end mb-3 togglers" v-if="showResults">
        <b-button variant="outline-dark" @click="expandAll(true)" class="small border-">Expand All</b-button>
        <b-button variant="outline-dark" @click="expandAll(false)" class="small">Collapse All</b-button>
      </b-row>
    </transition>
    <transition name="fade">
      <b-form @submit="onSubmit" v-if="showForm">
        <b-form-group
          id="input-group-calc-one-1"
          label="Assignment Rate per Day"
          label-cols="6"
          label-cols-md="7"
          label-for="input-calc-one-1"
          class="has-popup"
        >
          <b-input-group prepend="£">
            <vue-numeric
              id="input-calc-one-1"
              ref="assignmentRate"
              type="text"
              placeholder="Enter Amount"
              class="form-control"
              separator=","
              precision="2"
              v-model="form.assignmentRate"
            ></vue-numeric>
            <b-input-group-append v-b-tooltip.hover title="Assuming you take holiday pay">
              <b-input-group-text>
                <b-icon icon="question" variant="primary"></b-icon>
              </b-input-group-text>
              <b-input-group-text></b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <b-alert
            show
            variant="danger"
            v-if="$v.form.assignmentRate.$dirty && $v.form.assignmentRate.$error"
          >
            <div
              class="error"
              v-if="$v.form.assignmentRate.$dirty && !$v.form.assignmentRate.required"
            >This is required</div>
            <div
              class="error"
              v-if="$v.form.assignmentRate.$dirty && !$v.form.assignmentRate.between"
            >Please enter a number between 75 and 10000</div>
          </b-alert>
        </b-form-group>
        <b-form-group
          id="input-group-calc-one-2"
          label="Days Worked"
          label-cols="6"
          label-cols-md="7"
          label-for="input-calc-one-2"
        >
          <b-input-group>
            <b-form-input
              id="input-calc-one-2"
              v-model="form.daysWorked"
              required
              disabled
              placeholder="Enter Days"
            ></b-form-input>
            <b-input-group-append
              v-b-tooltip.hover
              title="Based on 260 working days minus 8 bank holiday days and 22 days holiday"
            >
              <b-input-group-text>
                <b-icon icon="question" variant="primary"></b-icon>
              </b-input-group-text>
              <b-input-group-text></b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-button type="submit" variant="primary" v-if="showResults == false">Calculate</b-button>
      </b-form>
    </transition>
    <transition name="fade">
      <div v-if="showResults">
        <CalculatorOneResults
          v-bind:results="results"
          v-on:resetEdit="onResetEdit"
          v-on:incrementTab="onIncrementTab"
        />
      </div>
    </transition>
  </b-tab>
</template>

<script>
import VueNumeric from "vue-numeric";
import CalculatorOneResults from "@/components/CalculatorOneResults";
import { resultFetcher } from "@/services/resultFetcher";
import { required, integer, minValue, between } from "vuelidate/lib/validators";

export default {
  props: ["tabIndex"],
  data() {
    return {
      form: {
        assignmentRate: null,
        daysWorked: 230
      },
      results: {},
      showForm: true,
      showResults: false
    };
  },
  methods: {
    async onSubmit(e) {
      e.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }
      // form submit after this
      this.results = await resultFetcher.calculatorOne({
        rate: this.form.assignmentRate,
        days: this.form.daysWorked
      });
      this.showResults = true;
      this.showForm = false;
    },
    expandAll(value) {
      if (value) {
        this.$store.commit("expandCollapseAll", {
          calculator: "one",
          action: "expand"
        });
      } else {
        this.$store.commit("expandCollapseAll", {
          calculator: "one",
          action: "collapse"
        });
      }
    },
    onResetEdit: async function() {
      this.showForm = true;
      this.showResults = false;
      await this.$refs.assignmentRate;
      this.$refs.assignmentRate.$el.focus();
      this.$refs.assignmentRate.$el.blur();
    },
    onIncrementTab() {
      // tell calc two to revert to input
      this.$store.commit("updateStoreValue", {
        key: "calcTwoRevert",
        value: true
      });
      // pass the event up the chain
      this.$emit("incrementTab");
    }
  },
  components: {
    CalculatorOneResults,
    VueNumeric
  },
  validations: {
    form: {
      assignmentRate: {
        required,
        between: between(75, 10000)
      },
      daysWorked: {
        required,
        integer,
        positive: minValue(0),
        between: between(1, 365)
      }
    }
  },
  watch: {
    showResults() {
      // if toggled on, pageview on calc one results
      if (this.showResults) {
        this.$gtag.pageview({
          page_title: "Calculator One Output",
          page_path: "/ir35-calculator-app/calculator-one-output"
        });
      }
      // if toggled off, pageview on calc one
      else {
        this.$gtag.pageview({
          page_title: "Calculator One Input",
          page_path: "/ir35-calculator-app/calculator-one-input"
        });
      }
    },
    tabIndex() {
      // if tabindex is 0 and showresults is on, pageview results
      if (this.tabIndex == 0 && this.showResults) {
        this.$gtag.pageview({
          page_title: "Calculator One Output",
          page_path: "/ir35-calculator-app/calculator-one-output"
        });
      } else if (this.tabIndex == 0 && !this.showResults) {
        // if tabindex is 0 and showresults is off, pageview input
        this.$gtag.pageview({
          page_title: "Calculator One Input",
          page_path: "/ir35-calculator-app/calculator-one-input"
        });
      }
    }
  },
  mounted() {
    //pageview on calc one
    this.$gtag.pageview({
      page_title: "Calculator One Input",
      page_path: "/ir35-calculator-app/calculator-one-input"
    });
  }
};
</script>
